import React from 'react';
import styled from 'styled-components';
import { viewSizeCalculator } from '../../utils';

const Slider = ({
  label = "Short Term Acute Care",
  min = 1,
  max = 10,
  step = 1,
  rating,
  onChange
}) => {
  const percentPosition = ((rating - min) / (max - min)) * 100;

  const updateValueFromPosition = (clientX, rect) => {
    const relativeX = clientX - rect.left;
    const percentage = Math.min(1, Math.max(0, relativeX / rect.width));
    const rawValue = percentage * (max - min) + min;
    const steppedValue = Math.round(rawValue / step) * step;
    return Math.min(max, Math.max(min, steppedValue));
  };

  const handleTrackClick = (e) => {
    const rect = e.currentTarget.getBoundingClientRect();
    const newValue = updateValueFromPosition(e.clientX, rect);
    onChange?.(newValue);
  };

  const handleDragStart = (e) => {
    e.preventDefault();
    const track = e.target.closest('[data-track]');
    const rect = track.getBoundingClientRect();

    const onMouseMove = (eMove) => {
      const newValue = updateValueFromPosition(eMove.clientX, rect);
      onChange?.(newValue);
    };

    const onMouseUp = () => {
      window.removeEventListener('mousemove', onMouseMove);
      window.removeEventListener('mouseup', onMouseUp);
    };

    window.addEventListener('mousemove', onMouseMove);
    window.addEventListener('mouseup', onMouseUp);
  };

  const dots = Array.from({ length: max - min + 1 }, (_, i) => (
    <Dot key={i} />
  ));

  return (
    <SliderWrapper>
      <Label>{label}</Label>
      <SliderTrackWrapper>
        <SliderTrack data-track onClick={handleTrackClick}>
          <DotsContainer>{dots}</DotsContainer>
          <ActiveThumb
            position={percentPosition}
            onMouseDown={handleDragStart}
          >
            <Tooltip>{rating}</Tooltip>
          </ActiveThumb>
        </SliderTrack>
      </SliderTrackWrapper>
    </SliderWrapper>
  );
};

export default Slider;

const SliderWrapper = styled.div`
  width: 100%;
`;

const Label = styled.div`
  font-size: ${() => `${viewSizeCalculator(1)}`};
  font-weight: 600;
  margin-bottom: 50px;
  color: #333333;
`;

const SliderTrack = styled.div`
  position: relative;
  height: 4px;
  background-color: #ddd;
  border-radius: 4px;
  display: flex;
  align-items: center;
`;

const DotsContainer = styled.div`
  position: absolute;
  width: 100%;
  display: flex;
  justify-content: space-between;
  top: 50%;
  transform: translateY(-50%);
`;

const Dot = styled.div`
  width: 8px;
  height: 8px;
  margin-top: 0.7px;
  background-color: #ccc;
  border-radius: 50%;
`;

const ActiveThumb = styled.div`
  position: absolute;
  top: 50%;
  left: ${({ position }) => position}%;
  transform: translate(-50%, -50%);
  width: 16px;
  height: 16px;
  background-color: #333;
  border-radius: 50%;
  cursor: pointer;
`;

const Tooltip = styled.div`
  position: absolute;
  top: -36px;
  left: 50%;
  transform: translateX(-50%);
  background-color: #333;
  color: #fff;
  font-size: 14px;
  padding: 4px 8px;
  border-radius: 4px;
  white-space: nowrap;

  &::after {
    content: '';
    position: absolute;
    bottom: -4px;
    left: 50%;
    transform: translateX(-50%);
    border-width: 6px 6px 0 6px;
    border-style: solid;
    border-color: #333 transparent transparent transparent;
  }
`;

export const SliderTrackWrapper = styled.div`
  padding-left: ${() => `${viewSizeCalculator(0.8)}`};
`;
